import axios from 'axios';
import store from './store/store';

export default function initAuth() {
  const remember = localStorage.getItem('remember');
  if (remember === 'false') {
    localStorage.removeItem('access-token');
    localStorage.removeItem('refresh-token');
    delete axios.defaults.headers.common.Authorization;
  }

  window.onbeforeunload = () => {
    const unloadRemember = localStorage.getItem('remember');
    if (unloadRemember === 'false') {
      localStorage.removeItem('access-token');
      localStorage.removeItem('refresh-token');
      delete axios.defaults.headers.common.Authorization;
    }
  };

  const storageAccessToken = localStorage.getItem('access-token');
  if (storageAccessToken) {
    axios.defaults.headers.common.Authorization = `Bearer ${storageAccessToken}`;
  }

  axios.interceptors.response.use(response => response, error => new Promise((resolve, reject) => {
    if (error.response !== undefined) {
      if (error.response.status === 401) {
        const refreshToken = localStorage.getItem('refresh-token');
        if (refreshToken !== null) {
          store.dispatch('refreshAccesToken')
            .then((response) => {
              const { accessToken } = response.data;
              const newConfig = error.config;
              newConfig.headers.Authorization = `Bearer ${accessToken}`;
              resolve(axios.request(newConfig));
            });
        } else {
          store.commit('setSessionExpired', true);
          store.commit('logout');
        }
      } else {
        reject(error);
      }
    } else {
      reject(error);
    }
  }));
}
